import { languageToLocale } from '@spa/shared/utils/language';
import { localeToHyphenFormat } from '@spa/shared/constants/locales';

const BASE_DAYS_IN_MONTH = 30;
const BASE_DAYS_IN_WEEK = 7;

const memoizedFormatter = () => {
  const cache = {};

  return (locale = 'en-GB', currencyCode = 'EUR') => {
    const key = `{${locale}#${currencyCode}}`;
    if (!cache[key]) {
      cache[key] = new Intl.NumberFormat(currencyCode === 'TRY' ? 'tr-TR' : locale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 0
      });
    }

    return cache[key];
  };
};

const getFormatter = memoizedFormatter();

export const toMoneyCoreFormat = (amount = 0) => amount * 100;
export const fromMoneyCoreFormat = (amount = 0) => amount / 100;

export const formatMoney = (amount = 0, currencyCode = 'EUR', language = 'en') => {
  const locale = localeToHyphenFormat(languageToLocale(language));

  return getFormatter(locale, currencyCode).format(fromMoneyCoreFormat(amount));
};

export const getCurrencySymbol = currencyCode => {
  const { value: symbol } = getFormatter('en-GB', currencyCode)
    .formatToParts()
    .find(({ type }) => type === 'currency') || { value: 'EUR' };

  return symbol;
};

export const formatMoneyPerCountry = (amount = 0, currencyCode = 'EUR', language = 'en', isUniresidences = true) => {
  if (isUniresidences) {
    const amountPerCountry = currencyCode === 'GBP' ? getWeeklyPrice(amount) : amount;

    return formatMoney(amountPerCountry, currencyCode, language);
  }

  return formatMoney(amount, currencyCode, language);
};

export const getWeeklyPrice = amount => Math.round(((amount / BASE_DAYS_IN_MONTH) * BASE_DAYS_IN_WEEK) / 100) * 100;
